<div
class="toast text-white"
role="alert"
aria-live="assertive"
aria-atomic="true"
>
<div class="toast-body">
  <div class="toast__wrapper">
    <div class="toast__content">
      <div class="toast__type text-dark">Warning</div>
      <div class="toast__message">{{message}}</div>
    </div>
  </div>
</div>
</div>
